angular.module('NiacsProjectApp.lms-review', [
])
.directive('lmsProjectView',['TaxonomyService',function(TaxonomyService){
    return {
        restrict: 'E',
        templateUrl: 'partials/export.html',
        scope: {
            project: '='
        },
        link: function($scope) {
            // this feels a little less than ideal but re-creating the workbook conditions required by the export step...
            $scope.niacs = niacs;
            TaxonomyService.get('state',function(data){
                $scope.vocab_state = data;
            });
            TaxonomyService.get('niacs_project_ownership',function(data){
                $scope.vocab_ownership = data;
            });
            TaxonomyService.get('niacs_feasibility',function(data){
                $scope.vocab_feasibility = data;
            });
            TaxonomyService.get('tactic_practicability',function(data){
                $scope.vocab_tactic_practicability = data;
            });
            TaxonomyService.get('niacs_vulnerability',function(data){
                $scope.vocab_vulnerability = data;
            });
        }
    };
}])
.controller('ReviewCourseProjectsCtrl',['$scope','$uibModalInstance','CourseProject','CourseOffering','ProjectService','theOffering',
    function($scope,$uibModalInstance,CourseProject,CourseOffering,ProjectService,theOffering){
    $scope.dismiss = $uibModalInstance.dismiss;
    CourseOffering.get({id:theOffering.id,offering:theOffering.version},function(offering){
        $scope.offering = offering;
        $scope.enrollmentMap = offering.enrollmentMap();
    });
   CourseProject.loadAll({
        'filter[field_related_course.id][value]': theOffering.uuid,
        'filter[field_related_course_offering][value]': theOffering.version
    }).then(function(projects) {
        $scope.projects = projects;
    });
    $scope.view = function(project) {
        ProjectService.expand(project,function(p) {
            $scope.viewProject = p;
        });
    };
}])
.directive('homeworkTextReview',[function(){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/homework-review-text.html',
        scope: {
            questions: '=',
            answers: '='
        }
    };
}])
.directive('homeworkExport',['$filter','$timeout',function($filter,$timeout){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/homework-export.html',
        scope: {
            homework: '=',
            projects: '=',
            offeringTitle: '@'
        },
        link: function($scope,$element,$attrs) {
            $scope.export = function() {
                if(!$scope.homework || !$scope.projects) {
                    return;
                }
                // build ordered list of author/answerMap
                var projectList = $filter('orderBy')(Object.keys($scope.projects).map(function(pid) { return $scope.projects[pid]; }),'author'),
                    answers = projectList.map(function(project) {
                        var student = {
                            author: project.author,
                            answers: {}
                        };
                        if(project.training.homework) {
                            Object.keys(project.training.homework).forEach(function(hwid) {
                                angular.extend(student.answers,project.training.homework[hwid]);
                            });
                        }
                        return student;
                    });
                // extract homeworks discarding the top level of keys (steps)
                var homeworks = [];
                Object.keys($scope.homework).forEach(function(stepid){
                    homeworks = homeworks.concat($scope.homework[stepid]);
                });
                // build csv array
                var titles = ['Question'];
                answers.forEach(function(student) { titles.push(student.author); });
                var csv = [titles];
                function rowGenerator(type) {
                    return function(qs){
                            var row = [qs.q];
                            answers.forEach(function(student) {
                                var a = student.answers[qs.id];
                                if(a) {
                                    if(type === 'long') {
                                        // long answer strip any new lines
                                        a = a.replace(/\n/g,' ');
                                    } else if (type === 'qual') {
                                        a = parseInt(a);
                                    }
                                }
                                row.push(a);
                            });
                            csv.push(row);
                        };
                }
                homeworks.forEach(function(hw){
                    // put a row in that's just the homework title
                    csv.push([hw.title]);
                    if(hw.long && hw.long.qs.length) {
                        hw.long.qs.forEach(rowGenerator('long'));
                    }
                    if(hw.qual && hw.qual.qs.length) {
                        // put a row in that's the qual title
                        csv.push([hw.qual.title]);
                        hw.qual.qs.forEach(rowGenerator('qual'));
                    }
                    if(hw.short && hw.short.qs.length) {
                        hw.short.qs.forEach(rowGenerator('short'));
                    }
                });

                // these are probably not necessary but Drupal has registered some of its
                // own code that is being run when CSV download links are clicked so explicitly
                // unbinding those handlers if set
                var $ = ($||jQuery);
                $(window).off('hashchange.form-fragment');
                $(document).off('click.form-fragment', 'a[href*="#"]');

                var csv_text = 'data:text/csv;base64,'+Base64.encode(csv.map(function(d){
                    return JSON.stringify(d);
                })
                .join('\n')
                .replace(/\\"/mg,'""') // replace \" with "" which is how double quotes are escaped in CSV
                .replace(/(^\[)|(\]$)/mg, '')); // drop open/close brackets from each row

                var link = $element.find('#homework-export-link')[0];
                //($||jQuery)('#homework-export-link')[0];
                link.href = encodeURI(csv_text);
                link.download = $scope.offeringTitle
                    .replace(/[\.'"]/g,'') // drop some special characters
                    .replace(/[\s-]/g,'_') // replace spaces and dashes with underscores
                    .replace(/_+/g,'_')+'.csv'; // collapse multiple underscores down to one
                $timeout(function(){
                    link.click();
                },250);
            };
        }
    };
}])
.directive('homeworkQualReview',['$filter',function($filter){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/homework-review-qual.html',
        scope: {
            homeworkQual: '=',
            answers: '=',
            projects: '='
        },
        link: function($scope,$element,$attrs) {
            // cut/paste from homework display from workbook
            function resize() {
                var labels = $element.find('.rangeLabel'),
                    values = $element.find('.rangeValue'),
                    maxW = 0;
                labels.each(function(){
                    var w = ($||jQuery)(this).width();
                    if(w > maxW) {
                        maxW = w;
                    }
                });
                function setW() {
                    ($||jQuery)(this).css('width',maxW);
                }
                labels.each(setW);
                values.each(setW);
            }
            // fetches a padded array of booleans stating who gave an answer of val
            function getAnswers(q,val) {
                var answers = [];
                if($scope.projectList && $scope.answers) {
                    var qAnswers = $scope.answers[q.id]||[];
                    angular.forEach($scope.projectList,function(project){
                        var answer = qAnswers.filter(function(a) {
                            return a.author === project.author && val === parseInt(a.answer);
                        });
                        answers.push(answer.length === 1);
                    });
                }
                return answers;
            }
            function xref() {
                if($scope.homeworkQual && $scope.qualRange && $scope.projectList) {
                    var answerMap = {};
                    angular.forEach($scope.homeworkQual.qs,function(q) {
                        answerMap[q.id] = {};
                        angular.forEach($scope.qualRange,function(i){
                            answerMap[q.id][i] = getAnswers(q,i);
                        });
                        answerMap[q.id]['total'] = Object.keys(answerMap[q.id]).reduce(function(sum,i){
                            i = parseInt(i);
                            return sum + answerMap[q.id][i].reduce(function(trues,yn){
                                return trues + (yn ? i : 0);
                            },0);
                        },0);
                    });
                    $scope.answerMap = answerMap;
                }
            }
            $scope.$watch('homeworkQual',function(){
                if($scope.homeworkQual) {
                    var qual = $scope.homeworkQual,
                        range = [],i;
                    for(i = qual.from.v; i <= qual.to.v; i++) {
                        range.push(i);
                    }
                    $scope.qualRange = range;
                    xref();
                    setTimeout(resize,500);
                }
            });

            $scope.$watch('projects',function() {
                if($scope.projects) {
                    $scope.projectList = $filter('orderBy')(Object.keys($scope.projects).map(function(pid){
                        return $scope.projects[pid];
                    }),'author');
                    xref();
                }
            },true/* deep */);
        }
    };
}])
.controller('ReviewCourseHomeworkCtrl',['$scope','$uibModalInstance','CourseProject','CourseOffering','theOffering',
    function($scope,$uibModalInstance,CourseProject,CourseOffering,theOffering){
    $scope.dismiss = $uibModalInstance.dismiss;
    // may or may not be latest go get the revision
    CourseOffering.get({id:theOffering.id,offering:theOffering.version},function(offering){
        $scope.offering = offering;
        $scope.enrollmentMap = offering.enrollmentMap();
    });
    $scope.toReview = {};
    $scope.toggleProject = function(project) {
        if($scope.toReview[project.id]) {
            delete $scope.toReview[project.id]; // don't leave errant keys
        } else {
            $scope.toReview[project.id] = project;
        }
    };
    $scope.anySelected = function() {
        return $scope.toReview && Object.keys($scope.toReview).length;
    };
    $scope.allSelected = function() {
        if(!$scope.projects || !$scope.projects.list || !$scope.projects.list.length) {
            return false;
        }
        for(var i = 0; i < $scope.projects.list.length; i++) {
            if(!$scope.toReview[$scope.projects.list[i].id]) {
                return false;
            }
        }
        return true;
    };
    $scope.toggleAll = function() {
        if($scope.allSelected()) {
            $scope.toReview = {};
        } else {
            angular.forEach($scope.projects.list,function(project){
                $scope.toReview[project.id] = project;
            });
        }
    };
   CourseProject.loadAll({
        'filter[field_related_course.id][value]': theOffering.uuid,
        'filter[field_related_course_offering][value]': theOffering.version
    }).then(function(projects){
        $scope.projects = projects;
        $scope.toggleAll();
    });
}])
.directive('homeworkReview',[function(){
    return {
        restrict: 'E',
        templateUrl: 'partials/lms/homework-review.html',
        scope: {
            homework: '=',
            projects: '='
        },
        link: function($scope) {
            // [{answer: '',author:''},...]
            function initAnswers() {
                var answers = {};
                if($scope.projects) {
                    Object.keys($scope.projects).forEach(function(pid){
                        var project = $scope.projects[pid],
                            author = project ? project.author : undefined;
                        if(project && project.training && project.training.homework) {
                            Object.keys(project.training.homework).forEach(function(hwid){
                                var homework = project.training.homework[hwid];
                                Object.keys(homework).forEach(function(qid){
                                    if(!answers[qid]) {
                                        answers[qid] = [];
                                    }
                                    answers[qid].push({
                                        answer: homework[qid],
                                        author: author
                                    });
                                });
                            });
                        }
                    });
                }
                $scope.answers = answers;
            }
            $scope.$watch('homework',initAnswers);
            $scope.$watch('projects',initAnswers,true/*deep*/);
        }
    };
}]);